<template>
    <div class="d-flex main">
        <div class="side d-flex" v-show="isMenuOpen">
            <SidebarComponent />
            <DatabarComponent :key="$route.params.chatId" @menuClose="isMenuOpen = false" />
        </div>

        <NavbarComponent @modelChanged="modelChanged" @deleteChat="chatDelete" :showModelSelect="false" :chatId="chatId"
            @menuOpen="isMenuOpen = true" />

        <div class="vertical-center">
            <h1>О нас</h1>
            <p>Добро пожаловать в {{ name }}, вашего умного спутника в путешествиях! 🚀</p>
            <p>Планирование поездки может быть стрессовым, но с {{ name }} это так же просто, как разговор. Мы —
                платформа
                с
                искусственным интеллектом, предназначенная для того, чтобы помочь вам исследовать мир без лишних хлопот.
                Ищете информацию о местах назначения, советы по путешествиям или лучший способ добраться из пункта А в
                пункт Б? Мы вас прикроем!</p>

            <p>{{ name }} — это не просто чат-бот. Это ваш персональный помощник в путешествиях. Нужно купить билеты на
                самолет или поезд? У нас есть все. Хотите посмотреть карты и маршруты? Легко. Ищете попутчиков,
                направляющихся в том же направлении? Наша функция "Go" соединяет вас с другими путешественниками.</p>

            <p>Наша миссия проста: сделать путешествия умнее, быстрее и без стресса. Больше никаких бесконечных поисков
                или запутанных бронирований — просто спросите {{ name }}, и мы позаботимся обо всем. Независимо от того,
                путешествуете ли вы как авантюрист, бизнесмен или просто планируете уикенд, мы здесь, чтобы сделать ваше
                путешествие гладким и приятным.</p>

            <p>Так куда же мы отправляемся дальше? 🌍✨</p>
        </div>
    </div>
</template>

<script>
import SidebarComponent from "@/components/SidebarComponent.vue";
import DatabarComponent from "@/components/DatabarComponent.vue";
import NavbarComponent from "@/components/NavbarComponent.vue";

export default {
    name: 'AboutView',
    components: {
        SidebarComponent,
        DatabarComponent,
        NavbarComponent
    },

    data() {
        return {
            isMenuOpen: window.innerWidth >= 810,
            chatId: null,
            name: this.$projectName
        };
    },
}
</script>